import React from 'react';
import './Loader.css';

interface LoaderProps {
  message?: string;
}

const Loader: React.FC<LoaderProps> = ({ message = 'Loading...' }) => {
  return (
    <div className="loader-overlay">
      <div className="loader-container">
        <div className="loader-spinner">
          <img 
            src="/assets/images/fav-loader.svg" 
            alt="Loading" 
            className="loader-icon"
          />
        </div>
        <p className="loader-message">{message}</p>
      </div>
    </div>
  );
};

export default Loader;
